import {
  callCallback,
  createContentRequest,
  stopLoadingShowError,
} from "../utils";
import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";
import { res_movies } from "../static-res";
import { getPageCollections } from "../api/worker";
import { PagesEnum } from "../api/api-models";
import { createCollectionRow } from "./collections-row";

export function createMoviesRoot(callback: (data: any) => void): void {
  tvx.InteractionPlugin.stopLoading();
  getPageCollections(PagesEnum.MOVIES).then((moviesPage) => {
    if (moviesPage != null) {
      const collectionsWithMovies = moviesPage.collections;

      const moviesRoot: MSXContentRoot = {
        cache: true,
        restore: true,
        reuse: true,
        type: "list",
        headline: res_movies(),
        flag: "movies",
        important: true,
        pages: [],
      };
      collectionsWithMovies
        .sort((a, b) => a.position - b.position)
        .forEach((collectionWithFictions) => {
          moviesRoot.pages.push(createCollectionRow(collectionWithFictions));
        });
      callCallback(moviesRoot, callback);
    } else {
      console.log("error occured");

      stopLoadingShowError({}, callback);
    }
  });
}
